// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_2PzqC4EbeGG6sqYgRsTqMF","tooltipClose":"_2VGKUlxoq-Q0U6HOvcsnUU"};